<template>
  <v-menu
    ref="dobMenu"
    v-model="dobMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    content-class="customCalendar__menu"
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <label class="titleForm" v-if="label">
        {{label }}
      </label>
      <v-text-field
        :value="showDob"
        readonly
        height="41"
        v-bind="attrs"
        v-on="on"
        solo
        :rules="isRequired == true ? dateRule : []"
        hide-details="auto"
        class="text-subtitle-2 text-md-subtitle-1 custom-calendar"
        :placeholder="placeholder"
        append-icon="fal fa-calendar-days"
        @click:append="dobMenu = !dobMenu"
        outlined
        dense
        @focus="$emit('focus')"
        :error-messages="errors"
      ></v-text-field>
      <!-- :locale="EnLanguage ? 'en' : 'fr-fr'" -->
    </template>
    <v-date-picker v-model="dob" :min="min" :max="max" :multiple="multiple" @change="saveDob" style="width: 100%">
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "DateSelect",
  components: {},
  data() {
    return {
      dobMenu: false,
      dob: null,
      now: this.$dayjs(),
      dateRule: [v => !!v || v === 0 || "Required"],
      formatISO: "DD/MM/YYYY"
    };
  },
  props: {
    value: { type: [Object, String, Array], default: () => {} },
    format: { type: String, default: "DD/MM/YYYY" },
    placeholder: { type: String, default: "dd/mm/yyyy" },
    min: { type: String, default: "" },
    max: { type: String, default: "" },
    isRequired: { type: Boolean, default: true },
    errors: {},
    name: {type: String, default: "" },
    label: {type: String, default: "" },
    multiple: { type: Boolean, default: false}
  },
  computed: {
    showDob() {
      if(this.dob) {
        if(this.multiple) {
          let listDate = []
          if(this.dob && this.dob.length !== 0) {
              this.dob.map(item => {
              listDate.push(this.$dayjs(item).format(this.format))
            })
            return listDate.toString()
          } else {
            return null
          }
        } else {
          return this.$dayjs(this.dob).format(this.format);
        }
      } else {
        return null
      }
    }
  },

  watch: {
    dob: {
      handler(val) {
        if (val) {
          this.$emit("input", val);
        }
      }

    },
    value: {
      immediate: true,
      handler(value) {
        this.dob = value;
      }
    }
  },
  methods: {
    saveDob(date) {
      this.$refs.dobMenu.save(date);
    }
  }
};
</script>
<style lang="scss">
.custom-calendar {
  .v-input__slot {
    padding-left: 0px !important;
    box-shadow: none !important;
    border-radius: 5px !important;
    min-height: 31px !important;
  }
  input {
    font-family: "Roboto", sans-serif !important;
  }
  .v-text-field__slot {
    padding-left: 12px !important;
  }
}
</style>
